import axios from "axios";

class ApiService {
  static async request(method, url, data = {}, headers = {}) {
    try {
      console.log("ApiService.request: method, url, data, headers →", method, url, data, headers);

      // Si el body es FormData (ej: subida de archivos), NO forzamos
      // Content-Type: axios debe setear multipart/form-data con su boundary.
      const isFormData = typeof FormData !== "undefined" && data instanceof FormData;

      const options = {
        method,
        url,
        headers: {
          Accept: "application/json",
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          ...headers,
        },
        params: method === "get" || method === "delete" ? data : undefined,
        data: method !== "get" && method !== "delete" ? data : undefined,
      };

      const response = await axios(options);
      return response.data;
    } catch (error) {
      console.error("Error de red o desconocido:", error);
      let err= {
        data: { error: 1, error_detalle: error.response ? error.response.data : error.message },
        statusCode: error.response ? error.response.status : 500,
      };
     
      return err;
    }
  }

  static get(url, headers = {}) {
    return this.request("get", url, {}, headers);
  }

  static post(url, data, headers = {}) {
    return this.request("post", url, data, headers);
  }

  static put(url, data, headers = {}) {
    return this.request("put", url, data, headers);
  }

  static patch(url, data, headers = {}) {
    return this.request("patch", url, data, headers);
  }

  static delete(url, headers = {}) {
    return this.request("delete", url, {}, headers);
  }
}

export default ApiService;
